<div class="group3">
  <h4 *ngIf="!hidetitle"> Solde </h4>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt129 && common.visibleChamp.cltObj129.visible && !isSoldeParChantier">
    <label class="col-sm-3 champ" style="padding:0px">Prix Négociés :</label>
    <div class="col-sm-9 champ text-underline historique" *ngIf="common.visibleChamp.cltObj129.vision" style="padding-right: 0px"
      [ngClass]="{'disabledbutton': add || (!add && edit && !common.visibleChamp.cltObj129.modifiable)}"
      (click)="showPrixNego()">
      Afficher
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt145 && common.visibleChamp.cltObj145.visible && !isSoldeParChantier">
    <label class="col-sm-3 champ" style="padding:0px">En compte :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" *ngIf="common.visibleChamp.cltObj145.vision" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit ||(add && !common.visibleChamp.cltObj145.creation) || (!add && edit && !common.visibleChamp.cltObj145.modifiable)"
        [(ngModel)]="detail.isCompte">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt146 && common.visibleChamp.cltObj146.visible && !isSoldeParChantier">
    <label class="col-sm-3 champ" style="padding:0px">Info Chant. Synth. :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" *ngIf="common.visibleChamp.cltObj146.vision" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || (add && !common.visibleChamp.cltObj146.creation) || (!add && edit && !common.visibleChamp.cltObj146.modifiable)"
        [(ngModel)]="detail.infoChanterSynthetique">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt147 && common.visibleChamp.cltObj147.visible && !isSoldeParChantier">
    <label class="col-sm-3 champ" style="padding:0px">Fact. Bon Immédiat. :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox"  *ngIf="common.visibleChamp.cltObj147.vision" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit ||(add && !common.visibleChamp.cltObj147.creation) || (!add && edit && !common.visibleChamp.cltObj147.modifiable)"
        [(ngModel)]="detail.factBonImmediat">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt100 && common.visibleChamp.cltObj100.visible && !isSoldeParChantier">
    <label class="col-sm-3 champ" style="padding:0px">Frais de Facturation :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" *ngIf="common.visibleChamp.cltObj100.vision" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || (add && !common.visibleChamp.cltObj100.creation) || (!add && edit && !common.visibleChamp.cltObj100.modifiable)"
        [(ngModel)]="detail.fraisFacturation">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt178 && common.visibleChamp.cltObj178.visible && !isSoldeParChantier">
    <label class="col-sm-3 champ" style="padding:0px">N° Bon Man. oblig. :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" *ngIf="common.visibleChamp.cltObj178.vision" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked" [disabled]="!edit ||
       (add && !common.visibleChamp.cltObj178.creation) || (!add && edit && !common.visibleChamp.cltObj178.modifiable)"
        [(ngModel)]="detail.numBonManuelObligatoire">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt73 && common.visibleChamp.cltObj73.visible && !isSoldeParChantier">
    <label class="col-sm-3 champ" style="padding:0px"> Mode de paie. :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <!--global 4-->

      <!-- <div *ngIf="!edit"> {{ typemodepaie }} </div> -->
      <div *ngIf="!edit">
        {{ (modepaie ? (modepaie.libelle || modepaie.libelleObjetEntite || typemodepaie) : (typemodepaie || '')) | maskInput: !common.visibleChamp.cltObj73.vision }}
      </div>
      <div *ngIf="edit && common.visibleChamp.cltObj73.vision"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj73.creation) || (!add && edit && !common.visibleChamp.cltObj73.modifiable)}">
        <app-autocomplete (selectfunction)="detail.modePaie = $event.id; modepaie = $event;" [results]="listMode"
          [highlight]="true" [id]="'modedepaie'" [isCombo]="true" [defaultselected]="modePaie" [disablefocus]="true"
          [defaultsearch]="modepaie ? modepaie.libelle || modepaie.libelleObjetEntite: (typemodepaie || '')">
        </app-autocomplete>
      </div>
    </div>
  </div>

  <div class=" items col-sm-12" *ngIf="(common.visibleChamp.clt148 && common.visibleChamp.cltObj148.visible) || isSoldeParChantier"
    [ngClass]="{'disabledbutton': !edit || add}">
    <div class="champ form-group"> Règlements </div>
    <div class="col-sm-12 withchamp" style="border: 1px solid #ddd; padding: 10px;"
      [ngClass]="{'disabledbutton': detail.isCompte}">
      <div class="form-group items col-sm-12"
        *ngIf="(common.visibleChamp.clt148 && common.visibleChamp.cltObj148.visible) || isSoldeParChantier">
        <label class="col-sm-3 champ" style="padding:0px"> Solde :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <div> {{ (common.toFixed(detail.solde || 0) + ' ' + devise) | maskInput: !common.visibleChamp.cltObj148.vision }}  </div>
          <!-- <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.solde"> -->
        </div>
      </div>
      <div class="form-group items col-sm-12" *ngIf="(common.visibleChamp.clt73 && common.visibleChamp.cltObj73.visible) || isSoldeParChantier">
        <label class="col-sm-3 champ" style="padding:0px"> Type de paie. :</label>
        <div class="col-sm-9 champ"
          [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj73.creation) || (!add && edit && !common.visibleChamp.cltObj73.modifiable)}"
          style="padding-right: 0px">
          <app-autocomplete *ngIf="common.visibleChamp.cltObj73.vision" (selectfunction)="reglement.modepaie = $event;" [results]="listMode" [highlight]="true"
            [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.modepaie" [disablefocus]="true"
            [defaultsearch]="reglement.modepaie ? reglement.modepaie.libelle || reglement.modepaie.libelleObjetEntite : ''">
          </app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12"
        *ngIf="(common.visibleChamp.clt212 && common.visibleChamp.cltObj212.visible) || isSoldeParChantier">
        <label class="col-sm-3 champ" style="padding:0px"> Compte :</label>
        <div class="col-sm-9 champ"
          [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj212.creation) || (!add && edit && !common.visibleChamp.cltObj212.modifiable) ||  (compteRegie && compteRegie.id)}"
          style="padding-right: 0px">
          <app-autocomplete *ngIf="common.visibleChamp.cltObj212.vision"  (searchfunction)="searchCompte($event)" (selectfunction)="reglement.compte = $event"
            [disablefocus]="true" [results]="listCompte" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
            [defaultselected]="reglement.compte"
            [defaultsearch]="reglement.compte ? (reglement.compte.libelleObjetEntite || reglement.compte.numCompte) : ''">
          </app-autocomplete>
        </div>
      </div>

      <div class="form-group items col-sm-12"
        *ngIf="(common.visibleChamp.clt148 && common.visibleChamp.cltObj148.visible) || isSoldeParChantier">
        <label class="col-sm-3 champ" style="padding:0px"> Montant :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="number" class="form-control" [(ngModel)]="reglement.montant"
            [disabled]="(add && !common.visibleChamp.cltObj148.creation) || (!add && edit && !common.visibleChamp.cltObj148.modifiable)">
        </div>
      </div>

      <div class="form-group items col-sm-12 text-center">
        <button class="uppercase btn-valider" (click)="valideRegelement()"> Valider </button>
        <button class="uppercase btn-close" (click)="initReglement()"> Annuler </button>
      </div>

    </div>
  </div>

</div>



<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error" style="white-space: pre-line;     font-family: Roboto-Black;
        font-size: 14px;"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-mdp" (click)="common.closeModal()">
        Fermer </button>
    </div>
  </div>
</ng-template>